import {computed}  from 'mobx';
import {auth} from 'shared/core';
import CalendarEvent from './CalendarEvent';

class BlockedDateEvent extends CalendarEvent {
  @computed get backgroundColor() {
    return '#EB4D28';
  }

  @computed get textColor() {
    return '#FFFFFF';
  }

  @computed get borderColor() {
    return '#EB4D28';
  }
  
  @computed get canViewDetails() {
    return auth.hasAccess('::MANAGE_TIME_OFF');
  }
}

export default BlockedDateEvent;
